// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__5DYPl","detailsBorder":"styles_detailsBorder__3pvJD"};